/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.2.1.0 (NJsonSchema v10.1.3.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/catch';

import { Observable } from 'rxjs/Observable';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { Http, Headers, ResponseContentType, Response } from '@angular/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export interface IEanerClient {
    login(model: LoginModel | null): Observable<LoginResult>;
    createEarner(earner: CreateEarnerRequest | null): Observable<boolean>;
    getAll(): Observable<FileResponse | null>;
    get(request: GetEarnerRequest | null): Observable<FileResponse | null>;
}

@Injectable()
export class EanerClient implements IEanerClient {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    login(model: LoginModel | null): Observable<LoginResult> {
        let url_ = this.baseUrl + "/Eaner/Login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processLogin(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processLogin(<any>response_);
                } catch (e) {
                    return <Observable<LoginResult>><any>Observable.throw(e);
                }
            } else
                return <Observable<LoginResult>><any>Observable.throw(response_);
        });
    }

    protected processLogin(response: Response): Observable<LoginResult> {
        const status = response.status;

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoginResult.fromJS(resultData200);
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<LoginResult>(<any>null);
    }

    createEarner(earner: CreateEarnerRequest | null): Observable<boolean> {
        let url_ = this.baseUrl + "/earner/createEarner";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(earner);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateEarner(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateEarner(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processCreateEarner(response: Response): Observable<boolean> {
        const status = response.status;

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }

    getAll(): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/earner/getAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            responseType: ResponseContentType.Blob,
            headers: new Headers({
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAll(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileResponse | null>><any>Observable.throw(response_);
        });
    }

    protected processGetAll(response: Response): Observable<FileResponse | null> {
        const status = response.status;

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Observable.of({ fileName: fileName, data: <any>response.blob(), status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.blob()).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileResponse | null>(<any>null);
    }

    get(request: GetEarnerRequest | null): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/earner/getEarner";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            method: "post",
            responseType: ResponseContentType.Blob,
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGet(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileResponse | null>><any>Observable.throw(response_);
        });
    }

    protected processGet(response: Response): Observable<FileResponse | null> {
        const status = response.status;

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Observable.of({ fileName: fileName, data: <any>response.blob(), status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.blob()).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileResponse | null>(<any>null);
    }
}

export interface IBadgeClient {
    createBadge(model: CreateBadgeRequest | null): Observable<FileResponse | null>;
    getBadge(request: GetBadgeRequest | null): Observable<FileResponse | null>;
    getBadgeTags(request: GetBadgeRequest | null): Observable<FileResponse | null>;
    getBadgeStandards(request: GetBadgeRequest | null): Observable<FileResponse | null>;
    getAllBadges(): Observable<FileResponse | null>;
    getAllEarnersBadges(userId: number): Observable<BadgeModel[]>;
    getBadgeCodes(): Observable<FileResponse | null>;
    getEmbedSettings(code: string | null): Observable<FileResponse | null>;
    checkEmail(email: string | null): Observable<FileResponse | null>;
    createUser(model: ApiAssertionModel | null): Observable<FileResponse | null>;
    assertBadge(assertion: ApiAssertionModel | null): Observable<FileResponse | null>;
}

@Injectable()
export class BadgeClient implements IBadgeClient {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    createBadge(model: CreateBadgeRequest | null): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/badge/createBadge";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            method: "post",
            responseType: ResponseContentType.Blob,
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateBadge(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateBadge(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileResponse | null>><any>Observable.throw(response_);
        });
    }

    protected processCreateBadge(response: Response): Observable<FileResponse | null> {
        const status = response.status;

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Observable.of({ fileName: fileName, data: <any>response.blob(), status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.blob()).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileResponse | null>(<any>null);
    }

    getBadge(request: GetBadgeRequest | null): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/badge/getBadge";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            method: "post",
            responseType: ResponseContentType.Blob,
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetBadge(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetBadge(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileResponse | null>><any>Observable.throw(response_);
        });
    }

    protected processGetBadge(response: Response): Observable<FileResponse | null> {
        const status = response.status;

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Observable.of({ fileName: fileName, data: <any>response.blob(), status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.blob()).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileResponse | null>(<any>null);
    }

    getBadgeTags(request: GetBadgeRequest | null): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/badge/getTags";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            method: "post",
            responseType: ResponseContentType.Blob,
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetBadgeTags(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetBadgeTags(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileResponse | null>><any>Observable.throw(response_);
        });
    }

    protected processGetBadgeTags(response: Response): Observable<FileResponse | null> {
        const status = response.status;

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Observable.of({ fileName: fileName, data: <any>response.blob(), status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.blob()).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileResponse | null>(<any>null);
    }

    getBadgeStandards(request: GetBadgeRequest | null): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/badge/getStandards";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            method: "post",
            responseType: ResponseContentType.Blob,
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetBadgeStandards(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetBadgeStandards(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileResponse | null>><any>Observable.throw(response_);
        });
    }

    protected processGetBadgeStandards(response: Response): Observable<FileResponse | null> {
        const status = response.status;

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Observable.of({ fileName: fileName, data: <any>response.blob(), status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.blob()).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileResponse | null>(<any>null);
    }

    getAllBadges(): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/badge/getAllBadges";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            responseType: ResponseContentType.Blob,
            headers: new Headers({
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllBadges(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllBadges(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileResponse | null>><any>Observable.throw(response_);
        });
    }

    protected processGetAllBadges(response: Response): Observable<FileResponse | null> {
        const status = response.status;

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Observable.of({ fileName: fileName, data: <any>response.blob(), status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.blob()).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileResponse | null>(<any>null);
    }

    getAllEarnersBadges(userId: number): Observable<BadgeModel[]> {
        let url_ = this.baseUrl + "/badge/getAllEarnersBadges?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllEarnersBadges(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllEarnersBadges(<any>response_);
                } catch (e) {
                    return <Observable<BadgeModel[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<BadgeModel[]>><any>Observable.throw(response_);
        });
    }

    protected processGetAllEarnersBadges(response: Response): Observable<BadgeModel[]> {
        const status = response.status;

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(BadgeModel.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<BadgeModel[]>(<any>null);
    }

    getBadgeCodes(): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/badge/getAllBadgeCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            responseType: ResponseContentType.Blob,
            headers: new Headers({
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetBadgeCodes(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetBadgeCodes(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileResponse | null>><any>Observable.throw(response_);
        });
    }

    protected processGetBadgeCodes(response: Response): Observable<FileResponse | null> {
        const status = response.status;

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Observable.of({ fileName: fileName, data: <any>response.blob(), status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.blob()).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileResponse | null>(<any>null);
    }

    getEmbedSettings(code: string | null): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/badge/GetEmbedSettings?";
        if (code === undefined)
            throw new Error("The parameter 'code' must be defined.");
        else
            url_ += "code=" + encodeURIComponent("" + code) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            responseType: ResponseContentType.Blob,
            headers: new Headers({
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetEmbedSettings(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetEmbedSettings(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileResponse | null>><any>Observable.throw(response_);
        });
    }

    protected processGetEmbedSettings(response: Response): Observable<FileResponse | null> {
        const status = response.status;

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Observable.of({ fileName: fileName, data: <any>response.blob(), status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.blob()).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileResponse | null>(<any>null);
    }

    checkEmail(email: string | null): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/badge/CheckEmail?";
        if (email === undefined)
            throw new Error("The parameter 'email' must be defined.");
        else
            url_ += "email=" + encodeURIComponent("" + email) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            responseType: ResponseContentType.Blob,
            headers: new Headers({
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCheckEmail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCheckEmail(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileResponse | null>><any>Observable.throw(response_);
        });
    }

    protected processCheckEmail(response: Response): Observable<FileResponse | null> {
        const status = response.status;

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Observable.of({ fileName: fileName, data: <any>response.blob(), status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.blob()).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileResponse | null>(<any>null);
    }

    createUser(model: ApiAssertionModel | null): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/badge/CreateUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            method: "post",
            responseType: ResponseContentType.Blob,
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateUser(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateUser(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileResponse | null>><any>Observable.throw(response_);
        });
    }

    protected processCreateUser(response: Response): Observable<FileResponse | null> {
        const status = response.status;

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Observable.of({ fileName: fileName, data: <any>response.blob(), status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.blob()).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileResponse | null>(<any>null);
    }

    assertBadge(assertion: ApiAssertionModel | null): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/badge/AssertBadge";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(assertion);

        let options_ : any = {
            body: content_,
            method: "post",
            responseType: ResponseContentType.Blob,
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processAssertBadge(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processAssertBadge(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileResponse | null>><any>Observable.throw(response_);
        });
    }

    protected processAssertBadge(response: Response): Observable<FileResponse | null> {
        const status = response.status;

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Observable.of({ fileName: fileName, data: <any>response.blob(), status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.blob()).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileResponse | null>(<any>null);
    }
}

export interface IImageClient {
    getBadgeIconThumbnail(org: string, fn: string): Observable<FileResponse | null>;
    getBadgeIcon(org: string, fn: string): Observable<FileResponse | null>;
    getOrganisationIcon(org: string, fn: string): Observable<FileResponse | null>;
}

@Injectable()
export class ImageClient implements IImageClient {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    getBadgeIconThumbnail(org: string, fn: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/badgeiconthumbnail/{org}/{fn}";
        if (org === undefined || org === null)
            throw new Error("The parameter 'org' must be defined.");
        url_ = url_.replace("{org}", encodeURIComponent("" + org)); 
        if (fn === undefined || fn === null)
            throw new Error("The parameter 'fn' must be defined.");
        url_ = url_.replace("{fn}", encodeURIComponent("" + fn)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            responseType: ResponseContentType.Blob,
            headers: new Headers({
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetBadgeIconThumbnail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetBadgeIconThumbnail(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileResponse | null>><any>Observable.throw(response_);
        });
    }

    protected processGetBadgeIconThumbnail(response: Response): Observable<FileResponse | null> {
        const status = response.status;

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Observable.of({ fileName: fileName, data: <any>response.blob(), status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.blob()).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileResponse | null>(<any>null);
    }

    getBadgeIcon(org: string, fn: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/badgeicon/{org}/{fn}";
        if (org === undefined || org === null)
            throw new Error("The parameter 'org' must be defined.");
        url_ = url_.replace("{org}", encodeURIComponent("" + org)); 
        if (fn === undefined || fn === null)
            throw new Error("The parameter 'fn' must be defined.");
        url_ = url_.replace("{fn}", encodeURIComponent("" + fn)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            responseType: ResponseContentType.Blob,
            headers: new Headers({
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetBadgeIcon(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetBadgeIcon(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileResponse | null>><any>Observable.throw(response_);
        });
    }

    protected processGetBadgeIcon(response: Response): Observable<FileResponse | null> {
        const status = response.status;

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Observable.of({ fileName: fileName, data: <any>response.blob(), status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.blob()).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileResponse | null>(<any>null);
    }

    getOrganisationIcon(org: string, fn: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/organisationicon/{org}/{fn}";
        if (org === undefined || org === null)
            throw new Error("The parameter 'org' must be defined.");
        url_ = url_.replace("{org}", encodeURIComponent("" + org)); 
        if (fn === undefined || fn === null)
            throw new Error("The parameter 'fn' must be defined.");
        url_ = url_.replace("{fn}", encodeURIComponent("" + fn)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            responseType: ResponseContentType.Blob,
            headers: new Headers({
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetOrganisationIcon(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetOrganisationIcon(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileResponse | null>><any>Observable.throw(response_);
        });
    }

    protected processGetOrganisationIcon(response: Response): Observable<FileResponse | null> {
        const status = response.status;

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Observable.of({ fileName: fileName, data: <any>response.blob(), status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(response.blob()).flatMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Observable.of<FileResponse | null>(<any>null);
    }
}

export class LoginResult implements ILoginResult {
    token?: string | undefined;
    userId: number;
    roles?: string[] | undefined;
    name?: string | undefined;
    status: PasswordLogInStatus;

    constructor(data?: ILoginResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["Token"];
            this.userId = _data["UserId"];
            if (Array.isArray(_data["Roles"])) {
                this.roles = [] as any;
                for (let item of _data["Roles"])
                    this.roles.push(item);
            }
            this.name = _data["Name"];
            this.status = _data["Status"];
        }
    }

    static fromJS(data: any): LoginResult {
        data = typeof data === 'object' ? data : {};
        let result = new LoginResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Token"] = this.token;
        data["UserId"] = this.userId;
        if (Array.isArray(this.roles)) {
            data["Roles"] = [];
            for (let item of this.roles)
                data["Roles"].push(item);
        }
        data["Name"] = this.name;
        data["Status"] = this.status;
        return data; 
    }
}

export interface ILoginResult {
    token?: string | undefined;
    userId: number;
    roles?: string[] | undefined;
    name?: string | undefined;
    status: PasswordLogInStatus;
}

export enum PasswordLogInStatus {
    LockedOut = 0,
    NoAllowableRole = 1,
    Succeeded = 2,
    UserNameAndPasswordNotFound = 3,
    UserNameNotFound = 4,
    EmailUnconfirmed = 5,
    DisabledAccount = 6,
}

export class LoginModel implements ILoginModel {
    userName?: string | undefined;
    password?: string | undefined;

    constructor(data?: ILoginModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["UserName"];
            this.password = _data["Password"];
        }
    }

    static fromJS(data: any): LoginModel {
        data = typeof data === 'object' ? data : {};
        let result = new LoginModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UserName"] = this.userName;
        data["Password"] = this.password;
        return data; 
    }
}

export interface ILoginModel {
    userName?: string | undefined;
    password?: string | undefined;
}

export class CreateEarnerRequest implements ICreateEarnerRequest {
    id: number;
    name?: string | undefined;
    email?: string | undefined;
    originatorReference?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    password?: string | undefined;

    constructor(data?: ICreateEarnerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.email = _data["Email"];
            this.originatorReference = _data["OriginatorReference"];
            this.firstName = _data["FirstName"];
            this.lastName = _data["LastName"];
            this.password = _data["Password"];
        }
    }

    static fromJS(data: any): CreateEarnerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEarnerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["Email"] = this.email;
        data["OriginatorReference"] = this.originatorReference;
        data["FirstName"] = this.firstName;
        data["LastName"] = this.lastName;
        data["Password"] = this.password;
        return data; 
    }
}

export interface ICreateEarnerRequest {
    id: number;
    name?: string | undefined;
    email?: string | undefined;
    originatorReference?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    password?: string | undefined;
}

export class GetEarnerRequest implements IGetEarnerRequest {
    userId?: string | undefined;
    email?: string | undefined;

    constructor(data?: IGetEarnerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): GetEarnerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetEarnerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["email"] = this.email;
        return data; 
    }
}

export interface IGetEarnerRequest {
    userId?: string | undefined;
    email?: string | undefined;
}

export class CreateBadgeRequest implements ICreateBadgeRequest {
    name?: string | undefined;
    description?: string | undefined;
    critetia?: string | undefined;
    expires: boolean;
    expiryValue: number;
    expiryUnit?: string | undefined;

    constructor(data?: ICreateBadgeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.critetia = _data["critetia"];
            this.expires = _data["expires"];
            this.expiryValue = _data["expiryValue"];
            this.expiryUnit = _data["expiryUnit"];
        }
    }

    static fromJS(data: any): CreateBadgeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBadgeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["critetia"] = this.critetia;
        data["expires"] = this.expires;
        data["expiryValue"] = this.expiryValue;
        data["expiryUnit"] = this.expiryUnit;
        return data; 
    }
}

export interface ICreateBadgeRequest {
    name?: string | undefined;
    description?: string | undefined;
    critetia?: string | undefined;
    expires: boolean;
    expiryValue: number;
    expiryUnit?: string | undefined;
}

export class GetBadgeRequest implements IGetBadgeRequest {
    badgeCode?: string | undefined;

    constructor(data?: IGetBadgeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.badgeCode = _data["BadgeCode"];
        }
    }

    static fromJS(data: any): GetBadgeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetBadgeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["BadgeCode"] = this.badgeCode;
        return data; 
    }
}

export interface IGetBadgeRequest {
    badgeCode?: string | undefined;
}

export class BadgeModel implements IBadgeModel {
    id: number;
    badgeCode?: string | undefined;
    name?: string | undefined;
    criteria?: string | undefined;
    description?: string | undefined;
    organisation?: OrganisationModel | undefined;
    status: BadgeStatus;
    expires: boolean;
    expiryValue: number;
    expiryUnit?: string | undefined;
    badgeStandards?: BadgeStandardModel[] | undefined;
    badgeTags?: BadgeTagModel[] | undefined;
    badgeIcon?: BadgeIconModel | undefined;
    badgeChildren?: ChildBadgeModel[] | undefined;

    constructor(data?: IBadgeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.badgeCode = _data["BadgeCode"];
            this.name = _data["Name"];
            this.criteria = _data["Criteria"];
            this.description = _data["Description"];
            this.organisation = _data["Organisation"] ? OrganisationModel.fromJS(_data["Organisation"]) : <any>undefined;
            this.status = _data["Status"];
            this.expires = _data["Expires"];
            this.expiryValue = _data["ExpiryValue"];
            this.expiryUnit = _data["ExpiryUnit"];
            if (Array.isArray(_data["BadgeStandards"])) {
                this.badgeStandards = [] as any;
                for (let item of _data["BadgeStandards"])
                    this.badgeStandards.push(BadgeStandardModel.fromJS(item));
            }
            if (Array.isArray(_data["BadgeTags"])) {
                this.badgeTags = [] as any;
                for (let item of _data["BadgeTags"])
                    this.badgeTags.push(BadgeTagModel.fromJS(item));
            }
            this.badgeIcon = _data["BadgeIcon"] ? BadgeIconModel.fromJS(_data["BadgeIcon"]) : <any>undefined;
            if (Array.isArray(_data["BadgeChildren"])) {
                this.badgeChildren = [] as any;
                for (let item of _data["BadgeChildren"])
                    this.badgeChildren.push(ChildBadgeModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BadgeModel {
        data = typeof data === 'object' ? data : {};
        let result = new BadgeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["BadgeCode"] = this.badgeCode;
        data["Name"] = this.name;
        data["Criteria"] = this.criteria;
        data["Description"] = this.description;
        data["Organisation"] = this.organisation ? this.organisation.toJSON() : <any>undefined;
        data["Status"] = this.status;
        data["Expires"] = this.expires;
        data["ExpiryValue"] = this.expiryValue;
        data["ExpiryUnit"] = this.expiryUnit;
        if (Array.isArray(this.badgeStandards)) {
            data["BadgeStandards"] = [];
            for (let item of this.badgeStandards)
                data["BadgeStandards"].push(item.toJSON());
        }
        if (Array.isArray(this.badgeTags)) {
            data["BadgeTags"] = [];
            for (let item of this.badgeTags)
                data["BadgeTags"].push(item.toJSON());
        }
        data["BadgeIcon"] = this.badgeIcon ? this.badgeIcon.toJSON() : <any>undefined;
        if (Array.isArray(this.badgeChildren)) {
            data["BadgeChildren"] = [];
            for (let item of this.badgeChildren)
                data["BadgeChildren"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IBadgeModel {
    id: number;
    badgeCode?: string | undefined;
    name?: string | undefined;
    criteria?: string | undefined;
    description?: string | undefined;
    organisation?: OrganisationModel | undefined;
    status: BadgeStatus;
    expires: boolean;
    expiryValue: number;
    expiryUnit?: string | undefined;
    badgeStandards?: BadgeStandardModel[] | undefined;
    badgeTags?: BadgeTagModel[] | undefined;
    badgeIcon?: BadgeIconModel | undefined;
    badgeChildren?: ChildBadgeModel[] | undefined;
}

export class OrganisationModel implements IOrganisationModel {
    id: number;
    uniqueKey?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    url?: string | undefined;
    status?: string | undefined;
    type?: string | undefined;
    iconFileName?: string | undefined;
    timestamp: Date;
    organisationAddresses?: AddressModel[] | undefined;
    organisationEmailAddresses?: EmailAddressModel[] | undefined;

    constructor(data?: IOrganisationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.uniqueKey = _data["UniqueKey"];
            this.name = _data["Name"];
            this.description = _data["Description"];
            this.url = _data["Url"];
            this.status = _data["Status"];
            this.type = _data["Type"];
            this.iconFileName = _data["IconFileName"];
            this.timestamp = _data["Timestamp"] ? new Date(_data["Timestamp"].toString()) : <any>undefined;
            if (Array.isArray(_data["OrganisationAddresses"])) {
                this.organisationAddresses = [] as any;
                for (let item of _data["OrganisationAddresses"])
                    this.organisationAddresses.push(AddressModel.fromJS(item));
            }
            if (Array.isArray(_data["OrganisationEmailAddresses"])) {
                this.organisationEmailAddresses = [] as any;
                for (let item of _data["OrganisationEmailAddresses"])
                    this.organisationEmailAddresses.push(EmailAddressModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrganisationModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrganisationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["UniqueKey"] = this.uniqueKey;
        data["Name"] = this.name;
        data["Description"] = this.description;
        data["Url"] = this.url;
        data["Status"] = this.status;
        data["Type"] = this.type;
        data["IconFileName"] = this.iconFileName;
        data["Timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        if (Array.isArray(this.organisationAddresses)) {
            data["OrganisationAddresses"] = [];
            for (let item of this.organisationAddresses)
                data["OrganisationAddresses"].push(item.toJSON());
        }
        if (Array.isArray(this.organisationEmailAddresses)) {
            data["OrganisationEmailAddresses"] = [];
            for (let item of this.organisationEmailAddresses)
                data["OrganisationEmailAddresses"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IOrganisationModel {
    id: number;
    uniqueKey?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    url?: string | undefined;
    status?: string | undefined;
    type?: string | undefined;
    iconFileName?: string | undefined;
    timestamp: Date;
    organisationAddresses?: AddressModel[] | undefined;
    organisationEmailAddresses?: EmailAddressModel[] | undefined;
}

export class AddressModel implements IAddressModel {
    id: number;
    name?: string | undefined;
    buildingNumber?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    address3?: string | undefined;
    city?: string | undefined;
    county?: string | undefined;
    country?: string | undefined;
    postcode?: string | undefined;
    phoneNumber?: string | undefined;
    mobile?: string | undefined;
    fax?: string | undefined;
    organisationId: number;

    constructor(data?: IAddressModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.buildingNumber = _data["BuildingNumber"];
            this.address1 = _data["Address1"];
            this.address2 = _data["Address2"];
            this.address3 = _data["Address3"];
            this.city = _data["City"];
            this.county = _data["County"];
            this.country = _data["Country"];
            this.postcode = _data["Postcode"];
            this.phoneNumber = _data["PhoneNumber"];
            this.mobile = _data["Mobile"];
            this.fax = _data["Fax"];
            this.organisationId = _data["OrganisationId"];
        }
    }

    static fromJS(data: any): AddressModel {
        data = typeof data === 'object' ? data : {};
        let result = new AddressModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["BuildingNumber"] = this.buildingNumber;
        data["Address1"] = this.address1;
        data["Address2"] = this.address2;
        data["Address3"] = this.address3;
        data["City"] = this.city;
        data["County"] = this.county;
        data["Country"] = this.country;
        data["Postcode"] = this.postcode;
        data["PhoneNumber"] = this.phoneNumber;
        data["Mobile"] = this.mobile;
        data["Fax"] = this.fax;
        data["OrganisationId"] = this.organisationId;
        return data; 
    }
}

export interface IAddressModel {
    id: number;
    name?: string | undefined;
    buildingNumber?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    address3?: string | undefined;
    city?: string | undefined;
    county?: string | undefined;
    country?: string | undefined;
    postcode?: string | undefined;
    phoneNumber?: string | undefined;
    mobile?: string | undefined;
    fax?: string | undefined;
    organisationId: number;
}

export class EmailAddressModel implements IEmailAddressModel {
    id: number;
    email?: string | undefined;
    isPrimary: boolean;
    organisationId: number;

    constructor(data?: IEmailAddressModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.email = _data["Email"];
            this.isPrimary = _data["IsPrimary"];
            this.organisationId = _data["OrganisationId"];
        }
    }

    static fromJS(data: any): EmailAddressModel {
        data = typeof data === 'object' ? data : {};
        let result = new EmailAddressModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Email"] = this.email;
        data["IsPrimary"] = this.isPrimary;
        data["OrganisationId"] = this.organisationId;
        return data; 
    }
}

export interface IEmailAddressModel {
    id: number;
    email?: string | undefined;
    isPrimary: boolean;
    organisationId: number;
}

export enum BadgeStatus {
    Inactive = 0,
    Active = 1,
    Archived = 2,
}

export class BadgeStandardModel implements IBadgeStandardModel {
    id: number;
    name?: string | undefined;
    description?: string | undefined;
    filename?: string | undefined;
    url?: string | undefined;
    standardType: BadgeStandardType;
    organisationFolderName?: string | undefined;
    organisationId: number;
    isSelected: boolean;

    constructor(data?: IBadgeStandardModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.description = _data["Description"];
            this.filename = _data["Filename"];
            this.url = _data["Url"];
            this.standardType = _data["StandardType"];
            this.organisationFolderName = _data["OrganisationFolderName"];
            this.organisationId = _data["OrganisationId"];
            this.isSelected = _data["IsSelected"];
        }
    }

    static fromJS(data: any): BadgeStandardModel {
        data = typeof data === 'object' ? data : {};
        let result = new BadgeStandardModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["Description"] = this.description;
        data["Filename"] = this.filename;
        data["Url"] = this.url;
        data["StandardType"] = this.standardType;
        data["OrganisationFolderName"] = this.organisationFolderName;
        data["OrganisationId"] = this.organisationId;
        data["IsSelected"] = this.isSelected;
        return data; 
    }
}

export interface IBadgeStandardModel {
    id: number;
    name?: string | undefined;
    description?: string | undefined;
    filename?: string | undefined;
    url?: string | undefined;
    standardType: BadgeStandardType;
    organisationFolderName?: string | undefined;
    organisationId: number;
    isSelected: boolean;
}

export enum BadgeStandardType {
    SpecificBadgeStandard = 1,
    GlobalBadgeStandard = 2,
}

export class BadgeTagModel implements IBadgeTagModel {
    id: number;
    description?: string | undefined;

    constructor(data?: IBadgeTagModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.description = _data["Description"];
        }
    }

    static fromJS(data: any): BadgeTagModel {
        data = typeof data === 'object' ? data : {};
        let result = new BadgeTagModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Description"] = this.description;
        return data; 
    }
}

export interface IBadgeTagModel {
    id: number;
    description?: string | undefined;
}

export class BadgeIconModel implements IBadgeIconModel {
    id: number;
    filename?: string | undefined;

    constructor(data?: IBadgeIconModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.filename = _data["Filename"];
        }
    }

    static fromJS(data: any): BadgeIconModel {
        data = typeof data === 'object' ? data : {};
        let result = new BadgeIconModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Filename"] = this.filename;
        return data; 
    }
}

export interface IBadgeIconModel {
    id: number;
    filename?: string | undefined;
}

export class ChildBadgeModel implements IChildBadgeModel {
    childId: number;
    badgeId: number;
    name?: string | undefined;

    constructor(data?: IChildBadgeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.childId = _data["ChildId"];
            this.badgeId = _data["BadgeId"];
            this.name = _data["Name"];
        }
    }

    static fromJS(data: any): ChildBadgeModel {
        data = typeof data === 'object' ? data : {};
        let result = new ChildBadgeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ChildId"] = this.childId;
        data["BadgeId"] = this.badgeId;
        data["Name"] = this.name;
        return data; 
    }
}

export interface IChildBadgeModel {
    childId: number;
    badgeId: number;
    name?: string | undefined;
}

export class ApiAssertionModel implements IApiAssertionModel {
    emailAddress?: string | undefined;
    badgeIds?: string[] | undefined;
    firstname?: string | undefined;
    lastName?: string | undefined;
    siteUrl?: string | undefined;

    constructor(data?: IApiAssertionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["EmailAddress"];
            if (Array.isArray(_data["BadgeIds"])) {
                this.badgeIds = [] as any;
                for (let item of _data["BadgeIds"])
                    this.badgeIds.push(item);
            }
            this.firstname = _data["Firstname"];
            this.lastName = _data["LastName"];
            this.siteUrl = _data["SiteUrl"];
        }
    }

    static fromJS(data: any): ApiAssertionModel {
        data = typeof data === 'object' ? data : {};
        let result = new ApiAssertionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["EmailAddress"] = this.emailAddress;
        if (Array.isArray(this.badgeIds)) {
            data["BadgeIds"] = [];
            for (let item of this.badgeIds)
                data["BadgeIds"].push(item);
        }
        data["Firstname"] = this.firstname;
        data["LastName"] = this.lastName;
        data["SiteUrl"] = this.siteUrl;
        return data; 
    }
}

export interface IApiAssertionModel {
    emailAddress?: string | undefined;
    badgeIds?: string[] | undefined;
    firstname?: string | undefined;
    lastName?: string | undefined;
    siteUrl?: string | undefined;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number; 
    response: string; 
    headers: { [key: string]: any; };
    result: any; 

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return Observable.throw(result);
    else
        return Observable.throw(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader(); 
            reader.onload = event => { 
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob); 
        }
    });
}


// WEBPACK FOOTER //
// ./src/api/swagger/ecomApi.ts